import { useEffect } from "react";
import "../styles/Home.css"
import { useNavigate } from "react-router";

const Tribute = () => {
    const navigate = useNavigate()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return<>
        <div className="tributeWrapper2">
            <h2>Tributes</h2>
            <div className="tributeButtons2">
                <button onClick={() => navigate("add")}>Write a Tribute</button>
            </div>

            <div className="tributeCardWrapper">

                <div className="tributeCard" onClick={() => navigate("Chief Engr. (Dr.) Donald Ike Igwegbu (Odera)")}>
                    <div className="tributeCardHeading">
                        <img src="" alt="" />
                        <div className="tributeCardPerson">
                            <h3>Chief Engr. (Dr.) Donald Ike Igwegbu (Odera)</h3>
                            <span>CEng., CMarEng., COREN., CMC., FIMC., FIMarEST - Son</span>
                        </div>
                    </div>
                    <div className="tributeInfo">
                        <p>{"<<"} We honor the life and legacy of an extraordinary wife, mother, grandmother, great grandmother, mother-in-law, cousin, niece and friend who was 83 years young, and one whose journey has been....  {">>"}</p>
                    </div>
                </div>
                

            </div>

            <div className="tributeButtons1">
                <button>Write a Tribute</button>
            </div>
        </div>

    </>

}

export default Tribute